import BaseViewModel, { BaseViewModelParams } from "./BaseViewModel";
import RedocUser from "src/Services";

class CurrentUserViewModel extends BaseViewModel {

	constructor ( params: BaseViewModelParams ) {
		super( params );
		RedocUser.updatedUserInfo()
			.then( result => {
				this.setValue(result?.userName ?? null );
			});
	};

};

export default CurrentUserViewModel;
